import { Chip, type ChipProps } from '@mui/material';
import { type User } from '@/lib/types';
import { HelpOutlineOutlined as QuestionIcon } from '@mui/icons-material';
import UserAvatar from '@/components/UserAvatar';

type AutocompleteValueChipProps = ChipProps & {
  user: User | undefined;
  userEmail: string;
};

const AutocompleteValueChip = ({
  user,
  userEmail,
  ...props
}: AutocompleteValueChipProps) => (
  <Chip
    label={typeof user !== 'undefined' ? user.name : userEmail}
    icon={
      typeof user !== 'undefined' ? (
        <UserAvatar user={user} size={24} />
      ) : (
        <QuestionIcon />
      )
    }
    {...props}
  />
);

export default AutocompleteValueChip;
